import {Component, OnInit} from '@angular/core';
import {SubformArray} from '../../../subform-array';

@Component({
    selector: 'app-apparatus-card-repair-form-array',
    templateUrl: 'apparatus-card-repair-form-array.component.html'
})

export class ApparatusCardRepairFormArrayComponent extends SubformArray {

}
